<!--
  Copyright (C) 2022 - Jeci SARL - https://jeci.fr

  This program is free software: you can redistribute it and/or modify
  it under the terms of the GNU Affero General Public License as
  published by the Free Software Foundation, either version 3 of the
  License, or (at your option) any later version.

  This program is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU Affero General Public License for more details.

  You should have received a copy of the GNU Affero General Public License
  along with this program.  If not, see https://www.gnu.org/licenses/agpl-3.0.html.
-->
<template>
  <PrimeImage v-if="id" :src="contentUrl" imageClass="image-displayed" />
</template>
<script>
import Image from "primevue/image";
import alfrescoFileService from "@/services/AlfrescoFileService.js";

export default {
  name: "OnlyImageDisplayed",
  components: {
    PrimeImage: Image,
  },
  props: {
    id: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      contentUrl: null,
    };
  },
  mounted() {
    this.loadImage();
  },
  methods: {
    loadImage() {
      this.contentUrl = alfrescoFileService.getContentUrl(this.id);
    },
  },
  computed: {
    hasContentUrl() {
      return this.contentUrl !== "";
    },
  },
};
</script>
<style scoped>
:deep(.image-displayed) {
  max-width: 100%;
  max-height: 100%;
  width: auto;
  height: auto;
  display: block;
}
</style>
